import { Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModuleService } from '@modules/application/services/module.service';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
    selector: 'app-module-layout',
    template: `
        <ng-container *ngIf="moduleAvailable$ | async; else notAvailable">
            <div class="tw-mb-4">
                <h2 class="tw-mb-1">{{ name }}</h2>
                <ng-container *ngIf="isTemplate(description); else text">
                    <ng-container *ngTemplateOutlet="description"></ng-container>
                </ng-container>
                <ng-template #text>
                    <p class="tw-m-0 tw-text-gray-500">{{ description }}</p>
                </ng-template>
            </div>
            <div *ngIf="navigation.length" class="tw-mb-4 tw-flex tw-gap-2 tw-flex-wrap">
                <button
                    *ngFor="let item of navigation"
                    nz-button
                    nzType="link"
                    routerLinkActive="ro-selected"
                    [routerLink]="item.url"
                    hoverClass="ro-hover-selected"
                >
                    <i *ngIf="item.iconClass" nz-icon [nzType]="item.iconClass" nzTheme="outline"></i>
                    {{ item.label }}
                </button>
            </div>
            <nz-divider class="tw-my-4"></nz-divider>
            <div>
                <router-outlet></router-outlet>
                <ng-content></ng-content>
            </div>
        </ng-container>
        <ng-template #notAvailable>
            <nz-result
                nzStatus="500"
                nzTitle="503"
                nzSubTitle="Disculpa, el contenido no está disponible en este momento."
            >
            </nz-result>
        </ng-template>
    `,
})
export class ModuleLayoutComponent {
    @Input() name: string;
    @Input() description: string | TemplateRef<any>;
    @Input() navigation: {
        label: string;
        url: string;
        iconClass?: string;
    }[] = [];

    moduleAvailable$ = combineLatest([this.moduleService.modules$, this.activeRoute.data]).pipe(
        map(([modules, routeData]) => {
            const moduleIdentifier = routeData.identifier;
            if (!moduleIdentifier) return;

            const currentModule = modules.find((m) => m.identifier === moduleIdentifier);
            if (currentModule.inactive_start_minutes === 0 && currentModule.inactive_end_minutes === 0) return true;

            const isInactive = this.moduleService.moduleIsInactive(currentModule);
            return !isInactive;
        })
    );

    constructor(private activeRoute: ActivatedRoute, private moduleService: ModuleService) {}

    @HostBinding('class')
    classes = 'tw-p-4 tw-block';

    isTemplate(content: TemplateRef<any> | string): boolean {
        return content instanceof TemplateRef;
    }
}
